/**
 * INT-0051 — the "Who's playing?" fork as two cards: I have a schedule
 * (primary, first) and Draft one for me. Lives at the bottom of the
 * create-organization step (owner 2026-10-21: in place of the inline
 * competition panel; the chosen mode travels to /create/add-teams?mode=) and
 * on the Who's playing? step itself when no choice was carried.
 */
import React from 'react';
import { FileUp, ListPlus } from 'lucide-react';

export type WhoIsPlayingMode = 'bring' | 'draft';

export default function WhoIsPlayingChoice({
  value,
  onSelect,
  noun = 'team',
  disabled = false,
}: {
  /** Highlighted card (selection mode); null when the cards are plain buttons. */
  value: WhoIsPlayingMode | null;
  onSelect: (mode: WhoIsPlayingMode) => void;
  noun?: string;
  disabled?: boolean;
}) {
  const card = (mode: WhoIsPlayingMode, Icon: typeof FileUp, title: string, body: string) => {
    const selected = value === mode;
    const primaryLook = value === null ? mode === 'bring' : selected;
    return (
      <button
        type="button"
        onClick={() => onSelect(mode)}
        disabled={disabled}
        aria-pressed={value === null ? undefined : selected}
        className={`flex flex-col items-start gap-2 rounded-2xl bg-card p-5 text-left shadow-lg transition disabled:opacity-60 ${
          primaryLook ? 'ring-2 ring-primary hover:bg-primary/5' : 'ring-1 ring-border hover:bg-muted/40'
        }`}
        data-tour={`create-teams-choice-${mode}`}
      >
        <Icon className={`h-6 w-6 ${primaryLook ? 'text-primary' : 'text-muted-foreground'}`} aria-hidden="true" />
        <span className="text-base font-semibold text-foreground">{title}</span>
        <span className="text-sm text-muted-foreground">{body}</span>
      </button>
    );
  };
  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2" data-tour="create-teams-choice" role={value === null ? undefined : 'group'} aria-label="Who's playing?">
      {card('bring', FileUp, 'I have a schedule', `Upload or paste it. We read the ${noun}s and games and put them on your site.`)}
      {card('draft', ListPlus, 'Draft one for me', `Type your ${noun} names and a first game date. We draft a round robin you can edit later.`)}
    </div>
  );
}
